import type { ProductKind } from '@iheartjane/types';
import type { DeepReadonly } from 'ts-essentials';

export const EQUIVALENCY_TYPE = 'equivalency';

export const EQUIVALENCY_UNIT = 'g';

export interface RuleProduct {
  _destroy?: boolean;
  cart_limit_rule_product_type_id: string | number;
  id: string | number;
  product_subtype: string | null;
  product_type: ProductKind;
}

export type CartLimitRule = DeepReadonly<{
  _destroy?: boolean;
  id?: string | number;
  limit_unit: string;
  limit_value: number;
  product_group_name: string;
  product_types: RuleProduct[];
  rule_type: 'product' | 'equivalency';
}>;

export interface CartLimitPolicy {
  cart_limit_rules: CartLimitRule[];
  id: string | number;
  name: string;
}
